uniform sampler2D uTexture;
uniform float uAlpha;
varying vec2 vUv;
varying vec4 vPosition;
uniform float uRadius;

void main() {

  vec2 uv = vUv;
  uv.x = 1.0 - uv.x;   

  vec4 texColor = texture2D(uTexture, uv);
  float normalizedY = (vPosition.y + uRadius) / (2.0 * uRadius);
  float transitionWidth = 0.1;
  float fadeMask = 1.0 - smoothstep(uAlpha - transitionWidth, uAlpha, normalizedY);
  gl_FragColor = vec4(texColor.rgb, texColor.a * fadeMask); 
  }